// import 'babel/polyfill'

// NOTE see https://github.com/shakacode/bootstrap-sass-loader if we you need to
// customize bootstrap variables
// import 'bootstrap-sass-loader'



import './source/imagesLoaded.js';
import './source/flickity.js';

import './modules/_hero-slider.js';
import './modules/_post-object';
import './modules/_query';
import './modules/_slideshow';
import './modules/_icon-slider';
import './modules/_tabs';
import './modules/_youtube-video';
import './modules/DropdownMenu';
import './modules/MobileMenu';
import './modules/PageContent';
import './modules/Slider.js';


import '../sass/app.scss';



// WEBPACK FOOTER //
// ./wp-content/themes/figpress-child/src/js/main.js